import { connect } from 'react-redux';
import type { ProductModificationStatus } from 'state/productModificationForm';
import * as ProductModificationSelectors from 'state/productModificationForm/productModificationForm.selector';
import type { AppState } from 'state/state.model';

interface OwnProps {
  tabId: string;
}

interface StateProps {
  status: ProductModificationStatus;
  hasErrors: boolean;
  isReady: boolean;
}

export type StatusProps = OwnProps & StateProps;

const mapStateToProps = (state: AppState, { tabId }: OwnProps): StateProps => {
  const status = ProductModificationSelectors.getStatus(state, tabId);
  const hasErrors = ProductModificationSelectors.hasErrors(state, tabId);
  const isReady = ProductModificationSelectors.isReady(state, tabId);

  return {
    status,
    hasErrors,
    isReady,
  };
};

export const connectStatus = connect(mapStateToProps);
